import 'babel-polyfill'
// import './lib/flexible.js'
import './lib/flexible2'
import clientMiddleware from 'lib/clientMiddleware'
import { saveStore } from './lib/common'
import 'velocity-animate'
import './directives/commonDirective.js'
import './filters/commonFilter'
import './lib/vueExends'
import 'registerModule'
import Vue from 'vue'
import Framework7Vue from 'framework7-vue'
import store from './store'
import App from './main.vue'
import VueResource from 'vue-resource'
import vuexRequestPlugin from 'plugins/vuex-request'
import commonPlugins from 'plugins/common-plugin'
import { globalConst as native } from './lib/const'

Vue.config.devtools = true
Vue.use(commonPlugins)
Vue.use(vuexRequestPlugin)
// Vue.mixin(vuexApiCallMixin)
window.Framework7.use(Framework7Vue)
Vue.use(VueResource)
// Vue.http.options.timeout = 3000
// Init App
export const bus = new Vue()
let app = new Vue({
  render: (h) => h(App),
  data () {
    return {}
  },
  // Register App Component
  created () {
    let downloader_store = sessionStorage.getItem('downloader_store')
    downloader_store && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(downloader_store)))
    this.$store.state.downLoader.pollTask = null
  },
  store
}).$mount('#app')
export { app }
export const applyClientMiddleware = clientMiddleware(store.commit)
/**
 * 添加 ajax 全局拦截器
 */
Vue.http.interceptors.push(function (request, next) {
  if (request.global) {app.$store.state.showLoading = true}
  next((response) => {
    if (request.global) {app.$store.state.showLoading = false}
    return response
  })
})

window.addEventListener('popstate', function () {
  app.$f7.dialog.close()

})
window.onbeforeunload = function () {
  saveStore(app.$store.state)
}
window.addEventListener('pagehide', function () {
  saveStore(app.$store.state)
}, false)
if (/Android/gi.test(navigator.userAgent)) {
  window.addEventListener('resize', function () {
    if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
      window.setTimeout(function () {
        document.activeElement.scrollIntoViewIfNeeded()
        // document.activeElement.scrollIntoView(false)
      }, 0)
    }
  })
}
